module.exports = __webpack_public_path__ + "assets/fonts/Georgia-Bold.0f8c304e.ttf";